import { Navigate } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider.js";
import { useRobotsMeta } from "../seo/useRobotsMeta.js";

/**
 * Root of the application origin, which has no landing page to show — but is
 * also MSAL's `redirectUri`.
 *
 * Entra returns the authentication response to the origin root as a URL
 * fragment, and MSAL only consumes it once MsalProvider has mounted and run
 * its redirect handling. Navigating on the first render would rewrite the URL
 * and discard that fragment, so the sign-in would be lost and every attempt
 * would land back on `/login`. Wait for MSAL to settle before moving.
 *
 * In practice a completed sign-in rarely reaches the redirect below: MSAL
 * navigates to the `redirectStartPage` set in AuthProvider once it has read
 * the response. This covers plain visits to the app origin's root.
 */
export function AppOriginEntry() {
  useRobotsMeta("noindex, nofollow");
  const { isReady } = useAuth();
  if (!isReady) return null;
  return <Navigate to="/home" replace />;
}
